import { createAsyncThunk } from '@reduxjs/toolkit';
import { StudentLoanApi } from 'api/StudentLoanApi';

import { ErrorResponse } from './ErrorResponse';

export interface UploadStudentAidDataData {
  applicationId: string;
  file: File;
}

export const createUploadEnrollmentFormThunk = (api: StudentLoanApi) =>
  createAsyncThunk('studentLoan/uploadEnrollmentForm', async (data: UploadStudentAidDataData, thunkApi) => {
    try {
      return await api.uploadEnrollmentForm(data.applicationId, data.file);
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);

      throw error;
    }
  });
